import React from 'react';
import { useScrollAnimation } from '../hooks/useScrollAnimation';

type ScrollAnimateProps = {
  children: React.ReactNode;
  className?: string;
};

export function ScrollAnimate({ children, className = '' }: ScrollAnimateProps) {
  const { ref, isVisible } = useScrollAnimation();
  return (
    <div
      ref={ref}
      className={`scroll-hidden ${isVisible ? 'scroll-visible' : ''} ${className}`}
    >
      {children}
    </div>
  );
}
